<form [formGroup]="formData" novalidate (ngSubmit)="onSubmit(1)">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <section class="negotiated-price" *ngIf="negotiatedPrice">
      <fieldset>
        <legend [translate]="'TITLES.NEGOTIATED_QUOTE'">
          Negotiated Quantity and Price
        </legend>
        <div class="row">
          <div class="col-md-3">
            <label for="" [translate]="'LABELS.QUOTE_NEG_COST'"
              >Total Cost per Unit</label
            >
            <span class="form-control">{{ negotiatedPrice.cost_per_unit }}</span>
          </div>
          <div class="col-md-3">
            <label for="" [translate]="'LABELS.QUOTE_NEG_UNIT_QUANTITY'"
              >Purchase Units Quantity</label
            >
            <span class="form-control">{{ negotiatedPrice.unit_quantity }}</span>
          </div>
          <div class="col-md-6">
            <label for="" [translate]="'LABELS.QUOTE_NEG_DIRECTION'"
              >Other Directions</label
            >
            <span class="form-control">{{ negotiatedPrice.other_details }}</span>
          </div>
        </div>
      </fieldset>
    </section>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="" [translate]="'LABELS.FACTORY'">Factory</label>
          <ng-select
            [items]="factoryService.factory$ | async"
            [multiple]="false"
            [closeOnSelect]="true"
            bindLabel="factory_name"
            bindValue="id"
            [searchable]="true"
            formControlName="factory_id"
            [hideSelected]="true"
          >
          </ng-select>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.factory_id"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" [translate]="'LABELS.QUOTE_NEG_FACTORY_COUNTRY'"
            >Factory Country</label
          >
          <input class="form-control" type="text" formControlName="country" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.country"
          >
          </control-messages>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="" [translate]="'LABELS.EXPIRY_DATE'">Expiry Date</label>
          <input class="form-control" type="date" formControlName="expiry_dt" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.expiry_dt"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="" [translate]="'LABELS.SAMPLE_PRICE'">Sample Price</label>
          <input class="form-control" type="text" formControlName="sample_price" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.sample_price"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="" [translate]="'LABELS.SAMPLE_LEAD_TIME'"
            >Sample Lead Time (days)</label
          >
          <input
            class="form-control"
            type="number"
            formControlName="sample_lead_time_days"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.sample_lead_time_days"
          >
          </control-messages>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label for="">Source SKU</label>
        <input class="form-control" type="text" formControlName="source_sku" />
      </div>
      <div class="col md-9">
        <div class="form-group">
          <label for="">{{ 'TITLES.QUOTATION_NOTES' | translate }}</label>
          <input type="text" class="form-control" formControlName="notes" />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="rfq.product_has_variants">
      <div class="col-md-12">
        <hr />
        <fieldset>
          <legend>Set variants that influence price</legend>
          <div
            class="variants-list form-group"
            *ngFor="let variant of rfq.product_variants; let i = index"
          >
            <h6 class="variant-name">{{ variant.variant_name }}</h6>
            <mat-checkbox
              color="primary"
              *ngFor="let term of variant.variant_terms; let vi = index"
              [formControl]="
                formData['controls'].variants_influence_price['controls'][i][
                  'controls'
                ][vi]
              "
            >
              {{ term }}
            </mat-checkbox>
          </div>
        </fieldset>
        <!-- <div class="form-group form-inline">
                    <label for="">SKU has Variants</label>
                    <select class="form-control" formControlName="variant_quote_type">
                        <option value="1" [translate]="'TEXT.VARIANT_QUOTE_TYPE_ALL_DIFFERENT'">All variants have different pricing</option>
                        <option value="2" [translate]="'TEXT.VARIANT_QUOTE_TYPE_ALL_SAME'">All variants have the same pricing</option>
                        <option value="3" [translate]="'TEXT.VARIANT_QUOTE_TYPE_SOME_DIFFERENT'">Some variants have different pricing</option>
                    </select>
                </div> -->
      </div>
    </div>
    <hr />
    <div class="form-group form-inline">
      <label for="">Production Lead Time (Days)</label>
      <input
        class="form-control ml-2"
        type="text"
        placeholder="Lead time"
        formControlName="lead_time_days_log1"
      />
      <control-messages
        [submitted]="submitted"
        [control]="formData.controls.lead_time_days_log1"
      >
      </control-messages>
    </div>

    <div class="form-group form-inline">
      <label for="">Unit</label>
      <ng-select
        [items]="rfq?.unit_of_measures || []"
        bindLabel="name"
        [multiple]="false"
        [clearable]="false"
        (change)="onUnitSelect($event)"
        [(ngModel)]="selectedUnit"
        [ngModelOptions]="{ standalone: true }"
        class="col-md-3 ml-2"
      >
      </ng-select>
    </div>

    <fieldset *ngIf="settingsSvc.masterfile$ | async as settings">
      <legend [translate]="'TITLES.TIERED_PRICING'">Base Tiered Pricing</legend>
      <table class="tiered_pricing">
        <thead>
          <tr>
            <th width="20">&nbsp;</th>
            <th width="120" class="text-center">
              <span [translate]="'GENERAL.QUANTITY'"> Quantity </span>
              &nbsp;
            </th>
            <th width="120" class="vertical-align-top text-center">
              <label for="">Logistics 1</label>
              <select
                formControlName="logistic_1"
                class="form-control"
                *ngIf="settings"
              >
                <option
                  *ngFor="let item of settings.LOGISTICS | keyvalue"
                  [value]="item.key"
                >
                  {{ item.value }}
                </option>
              </select>
              <control-messages
                [submitted]="submitted"
                [control]="formData.controls.logistic_1"
              >
              </control-messages>
            </th>
            <th class="text-center">
              <span [translate]="'SETTINGS.PAYMENT_TERMS'"> Payment Terms</span>
            </th>
            <!-- <th class="text-center">
                            <span [translate]="'SETTINGS.MARKUP'"> Markup </span>
                        </th> -->
            <th width="120" class="vertical-align-top text-center">
              <label for="">Logistics 2</label>
              <select
                formControlName="logistic_2"
                class="form-control"
                *ngIf="settings"
              >
                <option value="">&nbsp;</option>
                <option
                  *ngFor="let item of settings.LOGISTICS | keyvalue"
                  [value]="item.key"
                >
                  {{ item.value }}
                </option>
              </select>
            </th>
            <th *ngIf="formData.value.logistic_2" class="text-center">
              <span [translate]="'SETTINGS.PAYMENT_TERMS'"> Payment Terms</span>
            </th>
            <!-- <th *ngIf="formData.value.logistic_2" class="text-center">
                            <span [translate]="'SETTINGS.MARKUP'"> Markup </span>
                        </th> -->
          </tr>
        </thead>
        <tbody formArrayName="tiered_pricing">
          <tr
            *ngFor="
              let tp of formData['controls'].tiered_pricing['controls'];
              let i = index
            "
            [formGroupName]="i"
          >
            <td>{{ i + 1 }}</td>
            <td>
              <input
                class="form-control"
                type="number"
                placeholder="Quantity"
                formControlName="quantity"
                (input)="setPaymentMarkup(tp, i)"
              />
            </td>
            <td>
              <input
                class="form-control"
                type="number"
                placeholder="DDP Sea"
                formControlName="logistic_1"
                (input)="setPaymentMarkup(tp, i)"
              />
            </td>
            <td>
              <select
                formControlName="logistic_1_payment_term"
                class="form-control"
              >
                <option
                  *ngFor="let set of sysSettings.payment_terms"
                  [ngValue]="set"
                >
                  {{ set.label }}
                </option>
              </select>
            </td>
            <!-- <td>
                            <select formControlName="logistic_1_markup" class="form-control">
                                <option *ngFor="let markup of sysSettings.mark_up_structure" [ngValue]="markup">
                                    {{ markup.label }}
                                </option>
                            </select>
                        </td> -->
            <td>
              <span *ngIf="formData.value.logistic_2">
                <input
                  class="form-control"
                  type="number"
                  placeholder="DDP Air"
                  formControlName="logistic_2"
                  (input)="setPaymentMarkup(tp, i)"
                />
              </span>
              <span class="form-control" *ngIf="!formData.value.logistic_2"></span>
            </td>
            <td *ngIf="formData.value.logistic_2">
              <select
                formControlName="logistic_2_payment_term"
                class="form-control"
              >
                <option
                  *ngFor="let set of sysSettings.payment_terms"
                  [ngValue]="set"
                >
                  {{ set.label }}
                </option>
              </select>
            </td>
            <!-- <td *ngIf="formData.value.logistic_2">
                            <select formControlName="logistic_2_markup" class="form-control">
                                <option *ngFor="let markup of sysSettings.mark_up_structure" [ngValue]="markup">
                                    {{ markup.label }}
                                </option>
                            </select>
                        </td> -->
          </tr>
        </tbody>
        <!-- <tfoot>
                    <tr>
                        <td colspan="4">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <legend [translate]="'LABELS.PRODUCTION_LEAD_TIME'">Lead Time (Days)</legend>
                        </td>
                        <td>
                            <input class="form-control" type="text" placeholder="Lead time"
                                formControlName="lead_time_days_log1" />
                            <control-messages [submitted]="submitted" [control]="formData.controls.lead_time_days_log1">
                            </control-messages>
                        </td>
                        <td colspan="2">&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>
                            <input class="form-control" type="text" placeholder="Lead time"
                                formControlName="lead_time_days_log2" />
                            <control-messages [submitted]="submitted" [control]="formData.controls.lead_time_days_log2">
                            </control-messages>
                        </td>
                    </tr>
                </tfoot> -->
      </table>
    </fieldset>

    <fieldset class="file-upload">
      <legend [translate]="'TITLES.ATTACH_PRODUCT_FILES'">
        Attach Files / Pictures
      </legend>

      <div class="form-group">
        <input
          type="file"
          id="files"
          multiple
          placeholder="Upload product files or pictures"
          (change)="handleFileInput($event)"
        />
      </div>

      <div formArrayName="fileremarks">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th [translate]="'TITLES.FILE'">File</th>
              <th [translate]="'TITLES.FILE_REMARKS'">
                File Remarks/Description
              </th>
              <th [translate]="'TITLES.IS_PRIMARY'" class="text-center">
                Is Primary
              </th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let rmk of formData['controls'].fileremarks['controls'];
                let idx = index
              "
            >
              <td>
                <!-- <img [src]="filesToUpload[idx].previewSrc" alt="" width="60"
                                    *ngIf="filesToUpload[idx].previewSrc != ''" /> -->
                <a href="{{ filesToUpload[idx].previewSrc }}" target="_blank">{{
                  filesToUpload[idx].label
                }}</a>
                <span *ngIf="filesToUpload[idx].file">
                  {{ filesToUpload[idx].file.name }}
                </span>
              </td>
              <td>
                <span *ngIf="!filesToUpload[idx].file">{{ rmk.value }}</span>
                <input
                  *ngIf="filesToUpload[idx].file"
                  class="form-control"
                  type="text"
                  [formControlName]="idx"
                />
              </td>
              <td align="center">
                <input
                  type="radio"
                  value="{{ idx }}"
                  [formControl]="formData.controls.default_photo"
                />
              </td>
              <td class="actions">
                <a href="javascript:;" title="Remove" (click)="removeFile(idx)">
                  <i class="fas fa-times"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>

    <button
      type="button"
      (click)="onSubmit()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-success btn-elevate kt-btn-primary"
      [translate]="'BUTTONS.POST_QUOTATION'"
    >
      <i class="fas fa-save"></i> Post Quotation
    </button>

    <button
      type="submit"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit_draft"
      *ngIf="!quotation || quotation.status < 2"
      class="btn btn-info btn-elevate pull-left kt-btn-primary"
      [translate]="'BUTTONS.SAVE_AS_DRAFT'"
    >
      <i class="fab fa-firstdraft"></i> Save as Draft
    </button>
  </div>
</form>
